import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardHostComponent} from './dashboard-host/dashboard-host.component';
import {DashboardRoutingModule} from './dashboard-routing.module';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {RouterModule} from '@angular/router';
import {ChipsModule} from '@common/core/ui/chips/chips.module';
import {LinkIndexComponent} from './link/link-index/link-index.component';
import {CrupdateLinkModalComponent} from './link/crupdate-link-modal/crupdate-link-modal.component';
import {LinkShowComponent} from './link/link-show/link-show.component';
import {ChartsModule} from '@common/shared/charts/charts.module';
import {LinkGroupIndexComponent} from './link-group/link-group-index/link-group-index.component';
import {DashboardHomeComponent} from './dashboard-home/dashboard-home.component';
import {SharedModule} from '../shared/shared.module';
import {CrupdateLinkGroupModalComponent} from './link-group/crupdate-link-group-modal/crupdate-link-group-modal.component';
import {LinkGroupAnalyticsPageComponent} from './link-group/link-group-analytics-page/link-group-analytics-page.component';
import {AttachLinkModalComponent} from './link-group/attach-link-modal/attach-link-modal.component';
import {CustomDomainModule} from '@common/custom-domain/custom-domain.module';
import {LinkOverlayIndexComponent} from './link-overlay/link-overlay-index/link-overlay-index.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {LinkTypeMenuComponent} from './link/link-type-menu/link-type-menu.component';
import {DatetimeInputModule} from '@common/core/ui/datetime-input/datetime-input.module';
import {LinkUsageInfoComponent} from './dashboard-host/link-usage-info/link-usage-info.component';
import {UpgradePanelComponent} from './dashboard-host/upgrade-panel/upgrade-panel.component';
import {TrackingPixelIndexComponent} from './pixels/tracking-pixel-index/tracking-pixel-index.component';
import {CrupdateTrackingPixelModalComponent} from './pixels/crupdate-tracking-pixel-modal/crupdate-tracking-pixel-modal.component';
import {TranslationsModule} from '@common/core/translations/translations.module';
import {MatIconModule} from '@angular/material/icon';
import {FormatPipesModule} from '@common/core/ui/format-pipes/format-pipes.module';
import {ClickChartsModule} from './click-charts/click-charts.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {ColorPickerInputModule} from '@common/core/ui/color-picker/color-picker-input/color-picker-input.module';
import {LoadingIndicatorModule} from '@common/core/ui/loading-indicator/loading-indicator.module';
import {NoResultsMessageModule} from '@common/core/ui/no-results-message/no-results-message.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {InfoPopoverModule} from '@common/core/ui/info-popover/info-popover.module';
import {MaterialNavbarModule} from '@common/core/ui/material-navbar/material-navbar.module';
import {AdHostModule} from '@common/core/ui/ad-host/ad-host.module';
import {SlugControlModule} from '@common/shared/form-controls/slug-control/slug-control.module';
import {MatRadioModule} from '@angular/material/radio';
import {DatatableModule} from '@common/datatable/datatable.module';
import {SelectUserInputModule} from '@common/core/ui/select-user-input/select-user-input.module';
import {RemoveProtocolPipe} from './link/link-index/remove-protocol.pipe';
import {NoPermissionMessageComponent} from './permissions/no-permission-message/no-permission-message.component';
import {SkeletonModule} from '@common/core/ui/skeleton/skeleton.module';
import {LinkDomainComponent} from './link-domain/link-domain.component';
import {LinkPageIndexComponent} from './link-page-index/link-page-index.component';
import {CustomPageIndexModule} from '@common/pages/custom-pages-index/custom-page-index.module';
import {CrupdateLinkOverlayPageComponent} from './link-overlay/link-overlay-index/crupdate-link-overlay-page/crupdate-link-overlay-page.component';
import {GenericPagePreviewComponent} from './link-overlay/link-overlay-index/crupdate-link-overlay-page/generic-page-preview/generic-page-preview.component';
import {LinkGroupLinksIndexComponent} from './link-group/link-groups-links-index/link-group-links-index.component';
import {CsvExportInfoDialogModule} from '@common/csv/csv-info-dialog/csv-export-info-dialog.module';
import {UploadImageControlModule} from '@common/shared/form-controls/upload-image-control/upload-image-control.module';
import {UtmBuilderDialogComponent} from './link/utm-builder-dialog/utm-builder-dialog.component';
import {EnterKeybindDirective} from '@common/core/ui/enter-keybind.directive';
import {SvgImageModule} from '@common/core/ui/svg-image/svg-image.module';
import {WorkspaceModule} from '@common/workspaces/workspace.module';
import {WorkspaceSelectorModule} from '@common/workspaces/workspace-selector/workspace-selector.module';
import {UpgradeOverlayComponent} from './permissions/upgrade-overlay/upgrade-overlay.component';
import {SimplePermissionOverlayComponent} from './permissions/simple-permission-overlay/simple-permission-overlay.component';
import {
    WORKSPACE_CONFIG,
    WorkspaceConfig,
} from '@common/workspaces/workspace-config';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {LinkCreatedMessageComponent} from './link/crupdate-link-modal/link-created-message/link-created-message.component';
import {AppFooterModule} from '../shared/app-footer/app-footer.module';
import {BiolinkIndexComponent} from './biolinks/biolink-index/biolink-index.component';
import {ImageOrIconModule} from '@common/core/ui/image-or-icon/image-or-icon.module';
import {MatRippleModule} from '@angular/material/core';
import {BiolinkEditorModule} from './biolinks/biolink-editor/biolink-editor.module';
import {LinkOptionsFormModule} from './link/link-options-form/link-options-form.module';
import { SidenavModule } from '@common/shared/sidenav/sidenav.module';

@NgModule({
    declarations: [
        DashboardHostComponent,
        DashboardHomeComponent,
        LinkIndexComponent,
        CrupdateLinkModalComponent,
        LinkShowComponent,
        LinkGroupIndexComponent,
        CrupdateLinkGroupModalComponent,
        LinkGroupAnalyticsPageComponent,
        AttachLinkModalComponent,
        LinkOverlayIndexComponent,
        LinkTypeMenuComponent,
        LinkUsageInfoComponent,
        UpgradePanelComponent,
        TrackingPixelIndexComponent,
        CrupdateTrackingPixelModalComponent,
        EnterKeybindDirective,
        RemoveProtocolPipe,
        NoPermissionMessageComponent,
        LinkDomainComponent,
        LinkPageIndexComponent,
        CrupdateLinkOverlayPageComponent,
        GenericPagePreviewComponent,
        LinkGroupLinksIndexComponent,
        UtmBuilderDialogComponent,
        UpgradeOverlayComponent,
        SimplePermissionOverlayComponent,
        LinkCreatedMessageComponent,
        BiolinkIndexComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        DashboardRoutingModule,
        TranslationsModule,
        FormatPipesModule,
        ClickChartsModule,
        FormsModule,
        ReactiveFormsModule,
        ColorPickerInputModule,
        LoadingIndicatorModule,
        NoResultsMessageModule,
        InfoPopoverModule,
        MaterialNavbarModule,
        AdHostModule,
        SlugControlModule,
        CsvExportInfoDialogModule,
        UploadImageControlModule,
        SvgImageModule,
        AppFooterModule,
        WorkspaceModule,
        WorkspaceSelectorModule,
        LinkOptionsFormModule,
        SidenavModule,

        SkeletonModule,

        DatatableModule,
        SelectUserInputModule,

        SharedModule,
        ChartsModule,
        CustomDomainModule,
        CustomPageIndexModule,
        ChipsModule,
        DatetimeInputModule,

        BiolinkEditorModule,

        // material
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        MatButtonToggleModule,
        MatTabsModule,
        MatMenuModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        MatRadioModule,
        ImageOrIconModule,
        MatRippleModule,
    ],
    exports: [
        CrupdateLinkModalComponent,
    ],
    providers: [
        Modal,
        {
            provide: WORKSPACE_CONFIG,
            useValue: {
                description:
                    `Workspaces are like folders for your links, domains, groups and other resources. They're great for organising your campaigns, collaborating with teammates and managing different projects.`,
            } as WorkspaceConfig,
        },
    ],
})
export class DashboardModule {}
